import apiClient from "../../../api-client";
import getWrappedUseQuery from "../../helpers/getWrappedUseQuery";
import KEYS from "../keys";



export const useForumRoomGradesQuery = getWrappedUseQuery(KEYS.GET_FORUM_ROOM_GRADES, apiClient.ForumRoomGrade.get);
